import React from "react";
import "../../css/designSystem/Hero.css";
import PrimaryButton from "./buttons/PrimaryButton";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  showContactButton = true,
  showOverlay = true,
  compact = false,
  children,
}) {
  return (
    <section
      className={`hero background-container bg-gray-3 ${
        backgroundImage ? "hero-has-background" : ""
      } ${backgroundImage && showOverlay ? "hero-with-overlay" : ""} ${
        compact ? "hero-compact" : ""
      }`}
      style={
        backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined
      }
    >
      <div className="content-container column-center gap-xxxl hero-content-container">
        <div className="column-center gap-m hero-text">
          <h1 className="text-white">{renderLines(title)}</h1>
          <p className="subtitle-semibold text-primary-2 uppercase">
            {renderLines(subtitle)}
          </p>
          {/* {title && <div className="divider align-center"></div>} */}
          {children}
          {showContactButton && <PrimaryButton text="Contact Us" />}
        </div>
      </div>
    </section>
  );
}

export default Hero;
